/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Text,
  Image,
  Button,
  VStack,
  HStack,
} from '@chakra-ui/react';
import {
  WalletMultiButton,
  WalletDisconnectButton,
} from '@solana/wallet-adapter-react-ui';
import { useCallback, useEffect, useState } from 'react';

import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import { getAccountInfo, MINT_ADDRESS } from '../api/qdot';
import { getAssociatedTokenAddress } from '@solana/spl-token';
import { textTruncate } from '../utils';
require('@solana/wallet-adapter-react-ui/styles.css');

export function MusicqMenu({ isOpen, onClose, onAccountCreate }) {
  const { publicKey } = useWallet();
  const { connection } = useConnection();
  const [accountExists, setAccountExists] = useState(true);

  const handleCreatAccount = useCallback(
    () => onAccountCreate && onAccountCreate(),
    [onAccountCreate]
  );

  useEffect(() => {
    if (publicKey) {
      getAssociatedTokenAddress(MINT_ADDRESS, publicKey).then(tokenAddr =>
        getAccountInfo(connection, tokenAddr)
          .then(accountInfo => setAccountExists(true))
          .catch(error => setAccountExists(false))
      );
    }
    return () => setAccountExists(false);
  }, [publicKey, connection]);

  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        blockScrollOnMount={false}
      >
        <DrawerOverlay />
        <DrawerContent bg={'gray.800'}>
          <DrawerCloseButton color={'white'} />
          <DrawerHeader>
            <HStack>
              <Image
                height={10}
                width={10}
                src={`${process.env.PUBLIC_URL}/apple-touch-icon.png`}
              />
              <Text color={'white'}>Musicq</Text>
            </HStack>
          </DrawerHeader>

          <DrawerBody>
            <VStack spacing={5} align={'start'}>
              {publicKey ? (
                <WalletDisconnectButton
                  style={{
                    color: 'black',
                    backgroundColor: '#ECC94B',
                  }}
                >
                  {`${textTruncate(publicKey.toBase58(), 8)}`}
                </WalletDisconnectButton>
              ) : (
                <WalletMultiButton
                  style={{
                    color: 'black',
                    backgroundColor: '#ECC94B',
                  }}
                  onClick={onClose}
                >
                  Connect Wallet
                </WalletMultiButton>
              )}
              {!accountExists && publicKey && (
                <Button onClick={handleCreatAccount}>
                  Create QDOT Account
                </Button>
              )}
            </VStack>
          </DrawerBody>
          <DrawerFooter>
            <VStack align={'end'}>
              <Button
                colorScheme={'yellow'}
                onClick={() =>
                  window.open(
                    'https://trade.dexlab.space/#/market/BEqK9cuYBbGHRRipHqC4VLQb3rpfZUzi6NDoybb1jHm8'
                  )
                }
              >
                Buy QDOT
              </Button>
              <Button
                colorScheme={'yellow'}
                onClick={() =>
                  window.open(
                    'https://raydium.io/swap/?inputCurrency=HCpyiCXvziKByTGoQMLUmooAWBkCLvZmzB9D6TyPdACR&outputCurrency=EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v&fixed=in'
                  )
                }
              >
                Swap QDOT
              </Button>
            </VStack>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
